import React from "react";
import Typography from "@material-ui/core/Typography";
import TablaRangos from "../components/TablaRangos";
import {rangosResources} from "../endpoints";
import SnackbarAlert from "../components/SnackbarAlert";

class RangosTag extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            rangos:[],
            openSnack:false,
            severity: null,
            message:null,
        }
    }

    refrescarDatos = (estado,severity) =>{
        this.setState({openSnack:false, severity: null, message:null})
        if(severity === "success"){
            this.obtenerRangos()
        }
        this.setState({openSnack:true, severity:severity, message:estado})
    }

    obtenerRangos=()=>{
        this.setState({openSnack:false, severity: null, message:null})
        rangosResources.obtenerRangos().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({rangos:result.rangos})
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    UNSAFE_componentWillMount() {
        this.obtenerRangos()
    }
    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Rangos tag
                </Typography>
                <br/>
                <TablaRangos datos={this.state.rangos} refrescar={this.refrescarDatos}/>
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}
export default RangosTag;